import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FormsBuilderComponent } from './forms-builder.component'

const routes: Routes = [{
  path: '', component: FormsBuilderComponent,
  children: [
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FormsBuildingRoutingModule { }
